import React from "react";
import { Historique } from "./Facturation";
import Utilisateurs from "./Utilisateurs";
import { Eyebrow } from "./ui";

/* Journal & comptes : les comptes d'abord (qui a le droit d'entrer dans la console),
   l'historique ensuite (ce que chacun a fait). L'historique n'est pas propre à la
   facturation : un cours changé, une fiche élève corrigée, un réglage modifié y figurent
   aussi. */
export default function Journal() {
  return (
    <div className="space-y-8" data-testid="console-journal">
      <div>
        <Eyebrow>Traçabilité</Eyebrow>
        <h1 className="font-display text-3xl mt-1">Journal &amp; comptes</h1>
        <p className="text-sm text-[var(--muted)] mt-2 max-w-2xl">
          Les comptes qui ont accès à la console, puis tout ce qui a été fait dedans —
          factures, fiches élèves, planning, réglages — avec l'auteur, l'heure et ce qui a
          changé. Rien ne s'efface : on peut toujours dire qui a changé quoi.
        </p>
      </div>

      <Utilisateurs />

      <Historique />
    </div>
  );
}
